import React, { useState, useEffect } from 'react';
import logolight from '../assets/img/logo-light.png';
import logo from '../assets/img/logo/logo_low.png';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useQuery } from '@tanstack/react-query';

const Header = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Predefined categories
  const CATEGORIES = {
    1: "Off-Campus",
    2: "Walk-in Drive",
    3: "IT Jobs",
    4: "Non-IT Jobs",
    5: "Fresher Openings",
    6: "Campus Drive",
    7: "Govt Jobs",
    8: "Remote Jobs",
    9: "Internship Opportunities",
    10: "Startup Jobs",
    11: "International Jobs",
    12: "Part-time Jobs"
  };

  // Monitor window width for responsive design
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Helper function to get icon based on category name
  const getCategoryIcon = (categoryName) => {
    const name = categoryName.toLowerCase();
    if (name.includes('off-campus')) return 'fa-building';
    if (name.includes('walk-in') || name.includes('drive')) return 'fa-car';
    if (name.includes('it jobs')) return 'fa-laptop-code';
    if (name.includes('non-it')) return 'fa-briefcase';
    if (name.includes('fresher')) return 'fa-user-graduate';
    if (name.includes('campus')) return 'fa-university';
    if (name.includes('govt')) return 'fa-landmark';
    if (name.includes('remote')) return 'fa-house';
    if (name.includes('internship')) return 'fa-graduation-cap';
    if (name.includes('startup')) return 'fa-rocket';
    if (name.includes('international')) return 'fa-globe';
    if (name.includes('part-time')) return 'fa-clock';
    return 'fa-briefcase';
  };

  // Fetch categories with React Query
  const fetchCategories = async () => {
    const response = await fetch('https://ghanish.in/categories/');
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }
    return response.json();
  };

  const { data: categoriesData, isLoading, error } = useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
    onError: (err) => {
      console.error('Error fetching categories:', err);
    }
  });

  // Process categories data
  const categories = React.useMemo(() => {
    // Check if categoriesData exists and is an array
    if (!categoriesData || !Array.isArray(categoriesData)) {
      // Return fallback categories if API data isn't available or not in expected format
      return Object.entries(CATEGORIES).map(([id, name]) => ({
        id,
        displayName: name,
        icon: getCategoryIcon(name),
        urlSlug: name.toLowerCase().replace(/\s+/g, '-')
      }));
    }
    
    return categoriesData.map(category => ({
      id: category.id,
      displayName: category.name,
      icon: getCategoryIcon(category.name),
      urlSlug: category.name.toLowerCase().replace(/\s+/g, '-')
    }));
  }, [categoriesData]);

  // Get top 3 categories for navbar
  const topCategories = categories.slice(0, 3);

 

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light py-0">
        <div
          className="container-fluid"
          style={{ backgroundColor: "#26ae61", position: "relative", zIndex: 9999 }}
        >
          <Link className="navbar-brand" to="/">
            <img src={logo} className="logo logo-display" alt="" loading="lazy" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa-solid fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item me-3">
                <Link className="nav-link active text-white" to="/">
                  <i className="fa-solid fa-home me-1"></i>
                  Home
                </Link>
              </li>
              <li className="nav-item me-3">
                <Link className="nav-link text-white" to="/job-alerts">
                  <i className="fa-solid fa-bell me-1"></i>
                 Job Alerts
                </Link>
              </li>
              {isLoading ? (
                <li className="nav-item me-3">
                  <span className="nav-link text-white">
                    <i className="fa-solid fa-spinner fa-spin me-1"></i>
                    Loading...
                  </span>
                </li>
              ) : (
                topCategories.map((category) => (
                  <li className="nav-item me-3" key={category.id}>
                    <Link className="nav-link text-white" to={`/category/${category.urlSlug}`}>
                      <i className={`fa-solid ${category.icon} me-1`}></i>
                      {category.displayName}
                    </Link>
                  </li>
                ))
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
